(function () {
    'use strict';

    cookieConsent.confirmCookieNotice();

    var analyticsCookiesCheck = document.getElementById('analyticsCookiesCheck');
    var functionalCookiesCheck = document.getElementById('functionalCookiesCheck');

    analyticsCookiesCheck.checked = cookieConsent.analyticsEnabled;
    functionalCookiesCheck.checked = cookieConsent.functionalEnabled;

    $("#save-cookie-settings-button").click(function (){
        cookieConsent.applySettings(analyticsCookiesCheck.checked, functionalCookiesCheck.checked);
        $('#settings-saved-confirmation').addClass('settings-saved');
    });

}());